<!-- Custom Toast message for Reveal contact success -->
<ngb-alert type="custom" *ngIf="customToast">
  <div class="toast-div">
    <div class="icon">
      <i class="fa-solid fa-check"></i>
    </div>
    <div class="toast-text">
      <div>
        <strong>Congratulations</strong> we have found contacts from
        <span *ngFor="let provider of contactProviderData; let last=last">
          <span class="px-1" (click)="redirectToDataProviders(provider)">
            <img class="mr-1" [src]="'assets/icons/data-providers/' + provider + '.png'">
            <span style="color: #2e93a1; text-decoration: underline; font-weight: 600;">{{formattedProviderName(provider)}}</span>
            <span *ngIf="!last">,</span>
          </span>
        </span>
      </div>
      <div *ngIf="!candidateDetails?.iswebbtreeverified">
        If you want more details you can try
        <span class="font-weight-600" style="text-decoration: underline; color: #2e93a1;"
          (click)="handleToastRedirection()">Webbtree verified</span>
      </div>
    </div>
  </div>
</ngb-alert>

<!-- Toast message for success -->
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<!-- Toast message for error -->
<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<div *ngIf="isRevealContactLoading" class="personsearch-contact-slider text-center">
    <img src="assets/contact-loader-new.gif" alt="" style="height: 88px; width: 88px;">
    <div class="my-4 font-weight-600 f-14" *ngIf="!isRevealContactEmailLoading">Fetching contact details from data providers.</div>
    <div class="my-4 font-weight-600 f-14" *ngIf="isRevealContactEmailLoading">It’s taking a bit longer than expected. We’ll notify you at {{userData.loginemail}} once we find the contact details.</div>
  <!-- <mat-progress-bar mode="indeterminate" class="progress-bar" style="width: 400px; margin: auto;"></mat-progress-bar> -->
  <!-- <img src="assets/loader-bar.gif" alt=""> -->
</div>
<!-- contact reveal template -->
<ng-template #contactProvider class="radio-dropdown">
  <mat-expansion-panel #contactRevealPanel hideToggle="true" class="radio-expansion-panel">
    <mat-expansion-panel-header class="radio-expansion-panel-header"
    (click)="handleExpansionClick('contactRevealRadioBtn')">

    <div style="position: absolute; left: 280px; width: 100px;" class="d-flex">
      <!-- Phone number preview -->
      <span *ngIf="isPreviewAvailable.phone" class="contact-icons" matTooltip="Contact Number"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-phone-alt"></i></span>

      <!-- Personal email preview -->
      <span *ngIf="isPreviewAvailable.personal_email" class="contact-icons"
        matTooltip="Personal Email"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-envelope"></i></span>

      <!-- Professional email preview -->
      <span *ngIf="isPreviewAvailable.work_email" class="contact-icons" matTooltip="Professional Email"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-briefcase"></i></span>
    </div>

    <mat-panel-title>
        <mat-radio-button #contactRevealRadioBtn>
          <div class="radio-card">
            <div class="f-14 d-flex align-items-center">
              <i class="fa-solid fa-address-book f-16 mt-1" style="color: #2e93a1; margin:0px 17px 0px 4px;"></i>
              <span class="font-weight-600"> Contact Partners </span>
              <span class="ml-1" *ngIf="isPreviewPending">
                <img style="width: 20px;" src="assets/rolling-loader.gif" alt="">
              </span>

                <!-- <span class="f-12 text-9696"
                style="margin: 0px 8px;">Available</span> -->

              <!-- Phone number preview -->
              <!-- <span *ngIf="isPreviewAvailable.phone" class="contact-icons" matTooltip="Contact Number"
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-phone-alt"></i></span> -->

              <!-- Personal email preview -->
              <!-- <span *ngIf="isPreviewAvailable.personal_email" class="contact-icons"
                matTooltip="The total number of professionals within the company."
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-envelope"></i></span> -->

              <!-- Professional email preview -->
              <!-- <span *ngIf="isPreviewAvailable.work_email" class="contact-icons" matTooltip="Professional Email"
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-briefcase"></i></span> -->

              <span style="position: absolute; right: 20px;">
                <span class="coin-stack"> <i class="fas fa-coins"></i> </span> <span class="coins"> {{CREDITS_REQUIRED.CONTACT_PARTNER}}</span>
              </span>
            </div>
            <div class="f-12" style="margin: 8px 25px 0px 35px;">
              Get contact details instantly using our contact partners
            </div>
          </div>
        </mat-radio-button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="!isPreviewPending" class="expansion-body">
      <div>We will reveal the contact information through our trusted data partners -
        <span class="provider-icon">
          <img src="assets/icons/data-providers/signalhire.png" alt="">
          <span>SignalHire, </span>
        </span>
        <!-- This provider name is hidden for this task jira TRMS-2006 -->
        <!-- <span class="provider-icon">
          <img src="assets/icons/data-providers/pdl.png" alt="">
          <span>People Data Lab,</span>
        </span> -->
        <!-- <span class="provider-icon">
          <img src="assets/icons/data-providers/pipl.png" alt="">
          <span>PIPL, </span>
        </span>
          <span class="provider-icon">
          <img src="assets/icons/data-providers/contactout.png" alt="" matTooltip="ContactOut"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <span>ContactOut, </span>
        </span>
          &
         <span class="provider-icon">
          <img class="ml-0" src="assets/icons/data-providers/rocketreach.png" alt="" matTooltip="Rocketreach"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <span>Rocketreach</span> -->
          <span class="provider-icon">
          <img class="ml-0" src="assets/icons/data-providers/fullenrich.svg" alt="" matTooltip="FullEnrich"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <span>FullEnrich</span>
        </span>
        <!-- <span class="provider-icon">
          <img src="assets/icons/data-providers/nymblr.png" alt="">
          <span>Nimbler</span>
        </span> -->
      </div>
      <button data-testid="auto-person-search-contact-slider-button-1" class="btn-trms-medium"
        [ngClass]="{'bg-gray': candidateDetails?.hasOwnProperty('profileurl') && !candidateDetails?.profileurl}"
        [matTooltip]="candidateDetails?.hasOwnProperty('profileurl') && !candidateDetails?.profileurl ? 'Contact details unavailable due to insufficient profile data.' : ''"
        [matTooltipClass]="{ 'red-tooltip text-black': true }" style="margin-top: 16px;"
        [disabled]="candidateDetails?.hasOwnProperty('profileurl') && !candidateDetails?.profileurl"
        (click)="revealContactV2()">
        Reveal Contact
      </button>
    </div>
  </mat-expansion-panel>
</ng-template>

<!-- Retry contact reveal template -->
<ng-template #retryContactProvider class="radio-dropdown">
  <mat-expansion-panel #contactRevealPanel hideToggle="true" class="radio-expansion-panel">
    <mat-expansion-panel-header class="radio-expansion-panel-header"
    (click)="handleExpansionClick('contactRevealRadioBtn')">

    <div style="position: absolute; left: 280px; width: 100px;" class="d-flex">
      <!-- Phone number preview -->
      <span *ngIf="isPreviewAvailable.phone" class="contact-icons" matTooltip="Contact Number"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-phone-alt"></i></span>

      <!-- Personal email preview -->
      <span *ngIf="isPreviewAvailable.personal_email" class="contact-icons"
        matTooltip="Personal Email"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-envelope"></i></span>

      <!-- Professional email preview -->
      <span *ngIf="isPreviewAvailable.work_email" class="contact-icons" matTooltip="Professional Email"
        [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-briefcase"></i></span>
    </div>

    <mat-panel-title>
        <mat-radio-button #contactRevealRadioBtn [disabled]="isFullEnrichPending">
          <div class="radio-card">
            <div class="f-14 d-flex align-items-center">
              <i class="fa-solid fa-address-book f-16 mt-1" style="color: #2e93a1; margin:0px 17px 0px 4px;"></i>
              <span class="font-weight-600"> Retry Contact Reveal </span>
              <span class="ml-1" *ngIf="isPreviewPending">
                <img style="width: 20px;" src="assets/rolling-loader.gif" alt="">
              </span>

                <!-- <span class="f-12 text-9696"
                style="margin: 0px 8px;">Available</span> -->

              <!-- Phone number preview -->
              <!-- <span *ngIf="isPreviewAvailable.phone" class="contact-icons" matTooltip="Contact Number"
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-phone-alt"></i></span> -->

              <!-- Personal email preview -->
              <!-- <span *ngIf="isPreviewAvailable.personal_email" class="contact-icons"
                matTooltip="The total number of professionals within the company."
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-envelope"></i></span> -->

              <!-- Professional email preview -->
              <!-- <span *ngIf="isPreviewAvailable.work_email" class="contact-icons" matTooltip="Professional Email"
                [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-briefcase"></i></span> -->

              <span style="position: absolute; right: 20px;">
                <span class="coin-stack"> <i class="fas fa-coins"></i> </span> <span class="coins"> {{CREDITS_REQUIRED.RETRY_CONTACT_REVEAL}}</span>
              </span>
            </div>
            <div class="f-12" style="margin: 8px 25px 0px 35px;">
              Retry is available once per contact. No additional credits will be deducted.
            </div>
          </div>
        </mat-radio-button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="!isPreviewPending" class="expansion-body">
      <div>
        If you are not satisfied with the contact details found in the first attempt, Retry to check additional trusted data partners for available contact information.
      </div>
      <button data-testid="auto-person-search-contact-slider-button-2" class="btn-trms-medium" style="margin-top: 16px;" [disabled]="isFullEnrichPending"
        (click)="retryRevalContact()">
        Retry Contact Reveal
      </button>
    </div>
  </mat-expansion-panel>
</ng-template>

<!-- Loader if preview contact details are in pending -->
<ng-template #contactPreviewLoading>
    <!-- Loading div in contact reveal for preview api -->
    <div class="loading-preview" style="color: #484b59; margin-bottom: 7px;">
      <div>
        <img src="assets/contact-loader.gif" style="width: 48px;" alt="">
      </div>
      <div style="margin-left: 16px;">
        <div class="font-weight-600 f-14" style="margin-bottom: 8px;" >Searching for contacts availability from our contact partners ...</div>
        <div>
          Checking contacts from
          <span class="provider-icon" style="margin: 0px 4px; font-weight: 600;">
            <img src="assets/icons/data-providers/signalhire.png" alt="" title="signalHire">
            <span>signalHire, </span>
          </span>

          <span class="provider-icon" style="margin: 0px 4px; font-weight: 600;">
            <img src="assets/icons/data-providers/pdl.png" alt="" title="People Data Lab">
            <span>People Data Lab, </span>
          </span>
          <span class="provider-icon" style="margin: 0px 4px; font-weight: 600;">
            <img src="assets/icons/data-providers/pipl.png" alt="" title="PIPL">
            <span>PIPL, </span>
          </span>
          <span class="provider-icon">
          <img src="assets/icons/data-providers/contactout.png" alt="" matTooltip="ContactOut"
            [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <span>ContactOut, </span>
        </span>
                    &

          <span class="provider-icon" style="margin: 0px 4px; font-weight: 600;">
            <img class="ml-0" src="assets/icons/data-providers/rocketreach.png" alt="" title="Rocketreach">
            <span>Rocketreach</span>
          </span>
          <!-- <span class="provider-icon" style="margin: 0px 4px; font-weight: 600;">
            <img src="assets/icons/data-providers/nymblr.png" alt="">
            <span>Nimbler</span>
          </span> -->
        </div>
      </div>
    </div>
</ng-template>

<!-- Webtree-verified -->
<ng-template #webtreeVerified class="radio-dropdown" >
  <mat-expansion-panel #webtreeVerifiedExpansionPanel hideToggle="true" class="radio-expansion-panel">
    <mat-expansion-panel-header class="radio-expansion-panel-header"
      (click)="handleExpansionClick('webtreeVerifiedRadioBtn')">
      <mat-panel-title>
        <mat-radio-button #webtreeVerifiedRadioBtn>
          <div class="radio-card">
            <div class="f-14 d-flex align-items-center">
              <img src="../../assets/images/webbtree-icon.svg" style="margin:0px 8px 0px 4px;" alt="webbtree_logo">
              <span class="font-weight-600"> Webbtree Verified </span>
              <span class="f-12 popularTag">Popular</span>
              <span style="position: absolute; right: 20px;">
                <span class="coin-stack"> <i class="fas fa-coins"></i> </span>
                <span class="coins"> {{CREDITS_REQUIRED.WEBBTREE_VERIFIED}} </span>
              </span>
            </div>
            <div class="f-12" style="margin: 8px 25px 0px 35px;">
              Get a Human verified contact number within 4 hours
            </div>

          </div>
        </mat-radio-button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="expansion-body">
      <div>Webbtree team is committed to conducting thorough research to provide you with accurate and reliable
        human-verified contact details. This will enable you to directly reach out to candidates on their phones,
        streamlining the outreach process for you.</div>
      <button data-testid="auto-person-search-contact-slider-button-3" class="btn-trms-medium" style="margin: 16px 0px 16px 0px;" (click)="webtreeVerifiedRequest()">
        <span *ngIf="!isVerifiedLoading">
          Request Contact
        </span>
        <span *ngIf="isVerifiedLoading">
          <img class="rolling-loader" src="assets/rolling-loader-white.gif" alt="">
        </span>
      </button>
      <div>
        We will revert back to you with requested contact info on your Email ID within 4 hours or we will return the
        credits back to your account
      </div>
    </div>
  </mat-expansion-panel>
</ng-template>

<!-- Webtree Introdcuction -->
<ng-template #webtreeIntroduction class="radio-dropdown">
  <mat-expansion-panel #webtreeIntroExpansionPanel hideToggle="true" class="radio-expansion-panel">
    <mat-expansion-panel-header class="radio-expansion-panel-header"
      (click)="handleExpansionClick('webtreeIntroductionRadioBtn')">
      <mat-panel-title>
        <mat-radio-button #webtreeIntroductionRadioBtn>
          <div class="radio-card">
            <div class="f-14 d-flex align-items-center">
              <img src="../../assets/images/webbtree-icon.svg" style="margin:0px 8px 0px 4px;" alt="webbtree_logo">
              <span class="font-weight-600"> Webbtree Introduction </span>
              <span style="position: absolute; right: 20px;">
                <span class="coin-stack"> <i class="fas fa-coins"></i> </span> <span class="coins"> {{CREDITS_REQUIRED.WEBBTREE_INTRO}} </span>
              </span>
            </div>
            <div class="f-12" style="margin: 8px 25px 0px 35px;">
              We’ll schedule an Introduction call with the candidate on your behalf.
            </div>
          </div>
        </mat-radio-button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="expansion-body">
      <div>We're here to assist with connecting you to the candidate and arranging your first Introduction Call, giving
        you the freedom to focus on identifying top talent. Kindly share the opportunity or role you'd like to discuss
        with the candidate, along with your availability. Rest assured, we'll take care of reaching out and coordinating
        the call for you.</div>
      <div style="margin: 16px 0px;">
        <span class="f-14 font-weight-500 introdcuction-msg">Your Message to the
          Candidate</span>
        <textarea data-testid="auto-person-search-contact-slider-textarea-1" [formControl]="webbtreeIntroductionMessageForm"
          placeholder="Ex: I have a job opportunity as a Software Developer and I'm reaching out to candidates to join our team at Apple."
          rows="5"></textarea>
        <span class="text-danger"
          *ngIf="(webbtreeIntroductionMessageForm.touched || webbtreeIntroductionMessageForm.dirty) && !webbtreeIntroductionMessageForm?.value">Enter
          some data</span>
        <span class="text-danger"
          *ngIf="(webbtreeIntroductionMessageForm.touched || webbtreeIntroductionMessageForm.dirty) && webbtreeIntroductionMessageForm.hasError('maxlength')">Enter
          Data less than 1000 characters</span>
        <span class="text-danger"
          *ngIf="(webbtreeIntroductionMessageForm.touched || webbtreeIntroductionMessageForm.dirty) && webbtreeIntroductionMessageForm.hasError('minlength')">Please
          Enter more than 10 characters</span>
      </div>

      <div>
        <div class="f-14 font-weight-500 introdcuction-msg" style="margin-bottom: 12px;">Provide a few time slots you
          are
          available to connect with the candidate</div>
        <div [formGroup]="dateTimeMasterForm">
          <div *ngFor="let FC of formLength()" class="my-1 dateTimeForm">
            <div [formGroupName]="FC">
              <!-- date -->
              <input data-testid="auto-person-search-contact-slider-input-1" formControlName="date" class="timeSlots mr-4" type="date" [min]='minDateIntro'
                [max]='maxDateIntro'>
              <!-- From time of schedule call -->
              <input data-testid="auto-person-search-contact-slider-input-2" formControlName="fromTime" class="timeSlots" type="time">
              <span style="margin: 0px 12px;"> To </span>
              <!-- To time of schedule time -->
              <input data-testid="auto-person-search-contact-slider-input-3" formControlName="toTime" class="timeSlots" type="time">

              <select data-testid="auto-person-search-contact-slider-select-1" formControlName="timezone" class="timeSlots mx-4" style="color: #2e93a1; padding: 7px 0px;">

                <!-- <option [value]="null" selected class="timeSlots"><i></i> Timezone</option> -->
                <option *ngFor="let tz of timezones" [value]="tz" class="timeSlots">
                  🌐 {{ tz }}
                </option>
              </select>
              <span *ngIf="formLength()?.length > 1" (click)="deleteDateTimeFormSlot(FC)">
                <i class="fa-regular fa-trash mr-4"></i>
              </span>
              <span *ngIf="formLength()?.length < 3" class="addMore" (click)="addNewDateTimeFormSlot()">
                <i class="fa-solid fa-plus"></i>
              </span>

            </div>
          </div>
        </div>
        <p class="text-danger" *ngIf="dateTimeMasterForm.hasError('timeDiff')"> Invalid date or time</p>
        <p class="text-danger" *ngIf="dateTimeMasterForm.hasError('invalidValues')"> Invalid date or time</p>
        <p class="text-danger" *ngIf="dateTimeMasterForm.hasError('duplicate')"> Duplicate values not allowed</p>

        <button data-testid="auto-person-search-contact-slider-button-4" class="btn-trms-medium" style="margin: 16px 0px 16px 0px;" (click)="webtreeIntroductionRequest()">
          <span *ngIf="!isIntroductionLoading">Request a call</span>
          <span *ngIf="isIntroductionLoading">
            <img class="rolling-loader" src="assets/rolling-loader-white.gif" alt="">
          </span>
        </button>
      </div>

      <div>

      </div>
      <div>
        In the event that an Interested Introduction cannot be scheduled with your target profile within the next 5-7
        business days, credits will be reimbursed.
      </div>
    </div>
  </mat-expansion-panel>
</ng-template>

<!-- FullEnrich fallback still processing in background (TRMS-2797) -->
<ng-template #fullEnrichPending>
  <div class="webtree-sucess f-14 mb-4">
    <div class="font-weight-600 d-flex align-items-center">
      <img src="assets/rolling-loader.gif" style="width: 20px; margin-right: 8px;" alt="">
      {{ fullEnrichPendingMessage }}
    </div>
  </div>
</ng-template>

<!-- Balance coin -->
<ng-template #balanceCoin>
  Balance coins <span class="coin-stack ml-3"> <i class="fas fa-coins"></i> </span> <span class="coins"> {{totalCreditsAvailable}}
  </span>
</ng-template>

<!-- Select Alternative method to reveal -->
<ng-template #SelectRevealMethod let-text="headingText">
  <div class="d-flex justify-content-between mb-4">
    <div class="font-weight-500 f-14">
      {{text}}
      <!-- Select a method to reveal contact -->
    </div>
    <div>
      <ng-template [ngTemplateOutlet]="balanceCoin"></ng-template>
    </div>
  </div>
</ng-template>

<!-- Show All professional-email/work email -->
<ng-template #showAllWorkEmail>
  <div class="mb-6">
    <p class="text-9696 mb-2 font-weight-500" style="min-height: 20px;"> <i class="far fa-briefcase mr-2"></i>
      Professional
      Email</p>
    <div *ngFor="let email of work_email" class="onHover d-flex align-items-center justify-content-between mb-1"
      style="min-height: 25px !important;">
      <div>
        <img
         [src]="'../../assets/icons/data-providers/' +
            (email.enrichedvia.toLowerCase() === 'fullenrich'
              ? 'fullenrich.svg'
              : email.enrichedvia + (email.enrichedvia === 'added-manually' ? email.type : '') + '.png')"
          [alt]="email.enrichedvia" style="width: 15px;" *ngIf="email.enrichedvia" class="mr-1"
            matTooltip="{{email.enrichedvia}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <a data-testid="auto-person-search-contact-slider-a-1" href="mailto: {{email.contactdetail}}" class="personal-email" (click)="trackClickActivity(email)">{{email.contactdetail}}</a>
        <span class="primary-tag ml-1 f-10 font-weight-500" *ngIf="email.isprimary"
          style="color: #04363D;">Primary</span>
        <div class="onHoverActions contact-tag ml-1">
          <i class="fa-regular fa-copy pointer" matTooltip="Copy to clipboard"
            [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="copyToClipboard(email.contactdetail)"></i>
        </div>

        <!-- Edit button for manaually added contact -->
        <div
          *ngIf="enrichedfrom !== 'person-search-listing' && email.enrichedfrom !== 'person-search-listing' && email.enrichedvia == 'added-manually'"
          class="onHoverActions contact-tag ml-1" [ngStyle]="{'visibility' : canShowAddToContact ? 'hidden' : ''}">
          <span>
            <i class="fa-solid fa-pen-to-square" style="cursor: pointer;"
              (click)="!canShowAddToContact && editManualContact('professional', email)"></i>
          </span>
        </div>
      </div>
      <div class="d-inline-flex">
        <div class="onHoverActions helpful-tag f-12">
          <span class="text-9696 mr-2">Helpful</span>
          <span class="">
            {{ email.helpfulcount }}
            <i *ngIf="!email.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, true)"></i>
            <i *ngIf="email.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #2e93a180;"
              (click)="email.isvalid != 1 && markContactValidity(email, true)"></i>
          </span>
          <span class="">
            {{ email.unhelpfulcount }}
            <i *ngIf="email.isvalid == null" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, false)"></i>
            <i *ngIf="email.isvalid == 0" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #cd0f0f66;"
              (click)="email.isvalid != 0 && markContactValidity(email, false)"></i>
            <i *ngIf="email.isvalid == 1" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, false)"></i>
          </span>
        </div>
        <div class="ml-2">
          <span class="text-9696 f-10">{{ getLastSeenText(email) }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Show all personal email -->
<ng-template #showAllPersonalEmail>
  <div class="mb-4">
    <p class="text-9696 mb-1 font-weight-500"> <i class="far fa-envelope mr-2"></i>Personal Email</p>
    <div *ngFor="let email of personal_email" class="onHover d-flex align-items-center justify-content-between mb-1"
      style="min-height: 25px !important;">
      <div>
        <img [src]="'../../assets/icons/data-providers/' +
            (email.enrichedvia.toLowerCase() === 'fullenrich'
              ? 'fullenrich.svg'
              : email.enrichedvia + (email.enrichedvia === 'added-manually' ? email.type : '') + '.png')"
          [alt]="email.enrichedvia" style="width: 15px;" *ngIf="email.enrichedvia" class="mr-1"
          matTooltip="{{email.enrichedvia}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">
          <a data-testid="auto-person-search-contact-slider-a-2" href="mailto: {{email.contactdetail}}" (click)="trackClickActivity(email)" class="personal-email">{{email.contactdetail}}</a>
        <span class="primary-tag ml-1 f-10 font-weight-500" *ngIf="email.isprimary"
          style="color: #04363D;">Primary</span>
        <div class="onHoverActions contact-tag ml-1">
          <i class="fa-regular fa-copy pointer" matTooltip="Copy to clipboard"
            [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="copyToClipboard(email.contactdetail)"></i>
          <i class="fa-regular fa-envelope ml-2 pointer" (click)="OpenSendEmailModule(email.contactdetail)"></i>
        </div>

        <!-- Edit button for manaually added contact -->
        <div
          *ngIf="enrichedfrom !== 'person-search-listing' && email.enrichedfrom !== 'person-search-listing' && email.enrichedvia == 'added-manually'"
          class="onHoverActions contact-tag ml-1" [ngStyle]="{'visibility' : canShowAddToContact ? 'hidden' : ''}">
          <span>
            <i class="fa-solid fa-pen-to-square" style="cursor: pointer;"
              (click)="!canShowAddToContact && editManualContact('personal', email)"></i>
          </span>
        </div>
      </div>
      <div class="d-inline-flex">
        <div class="onHoverActions helpful-tag f-12">
          <span class="text-9696 mr-2">Helpful</span>
          <span class="">
            {{ email.helpfulcount }}
            <i *ngIf="!email.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, true)"></i>
            <i *ngIf="email.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #2e93a180;"
              (click)="email.isvalid != 1 && markContactValidity(email, true)"></i>
          </span>
          <span class="">
            {{ email.unhelpfulcount }}
            <i *ngIf="email.isvalid == null" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, false)"></i>
            <i *ngIf="email.isvalid == 0" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #cd0f0f66;"
              (click)="email.isvalid != 0 && markContactValidity(email, false)"></i>
            <i *ngIf="email.isvalid == 1" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(email, false)"></i>
          </span>
        </div>
        <div class="ml-2">
          <span class="text-9696 f-10">{{ getLastSeenText(email) }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Show all phone numbers -->
<ng-template #showAllPhone>
  <div class="mb-4">
    <p class="text-9696 mb-2 font-weight-500"> <i class="far fa-phone mr-2"></i> Contact Number</p>
    <div *ngFor="let phone of phones" class="onHover d-flex align-items-center justify-content-between mb-1"
      style="min-height: 25px !important;">
      <div class="">
        <img [src]="'../../assets/icons/data-providers/' +
            (phone.enrichedvia.toLowerCase() === 'fullenrich'
              ? 'fullenrich.svg'
              : phone.enrichedvia + (phone.enrichedvia === 'added-manually' ? phone.type : '') + '.png')"
          [alt]="phone.enrichedvia" style="width: 15px;" *ngIf="phone.enrichedvia" class="mr-1"
          matTooltip="{{phone.enrichedvia}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"> {{phone.contactdetail}}
        <span class="primary-tag ml-1 f-10 font-weight-500" *ngIf="phone.isprimary"
          style="color: #04363D;">Primary</span>
        <a data-testid="auto-person-search-contact-slider-a-3" href="{{getWhatsappLink(phone.contactdetail)}}" target="_blank" rel="noopener noreferrer"
          *ngIf="phone.isprimary">
          <img src="../../assets/images/whatsapp.svg" class="ml-2" height="15px" width="15px" alt="whatsapp-logo">
        </a>
        <div class="onHoverActions contact-tag ml-1">
          <i class="fa-regular fa-copy pointer" matTooltip="Copy to clipboard"
            [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="copyToClipboard(phone.contactdetail)"></i>
        </div>

        <!-- Edit button for manaually added contact -->
        <div
          *ngIf="enrichedfrom !== 'person-search-listing' && phone.enrichedfrom !== 'person-search-listing' && phone.enrichedvia == 'added-manually'"
          class="onHoverActions contact-tag ml-1" [ngStyle]="{'visibility' : canShowAddToContact ? 'hidden' : ''}">
          <span>
            <i class="fa-solid fa-pen-to-square" style="cursor: pointer;"
              (click)=" !canShowAddToContact && editManualContact('contact_number', phone)"></i>
          </span>
        </div>
      </div>
      <div class="d-inline-flex">
        <div class="onHoverActions helpful-tag f-12">
          <span class="text-9696 mr-2">Helpful</span>
          <span class="">
            {{ phone.helpfulcount }}
            <i *ngIf="!phone.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(phone, true)"></i>
            <i *ngIf="phone.isvalid" class="fa-solid fa-thumbs-up mx-1 pointer" style="color: #2e93a180;"
              (click)="phone.isvalid != 1 && markContactValidity(phone, true)"></i>
          </span>
          <span class="">
            {{ phone.unhelpfulcount }}
            <i *ngIf="phone.isvalid == null" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(phone, false)"></i>
            <i *ngIf="phone.isvalid == 0" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #cd0f0f66;"
              (click)="phone.isvalid != 0 && markContactValidity(phone, false)"></i>
            <i *ngIf="phone.isvalid == 1" class="fa-solid fa-thumbs-down mx-1 pointer" style="color: #d9d9d9;"
              (click)="markContactValidity(phone, false)"></i>
          </span>
        </div>
        <div class="ml-2">
          <span class="text-9696 f-10">{{ getLastSeenText(phone) }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #noCreditsCE class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-person-search-contact-slider-button-5" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
          <p class="" *ngIf="!isteamMember">You have exhausted your limit for contacts enmrichments</p>
          <p class="" *ngIf="isteamMember">You have exhausted your limit to contacts enmrichments Request more credits
            from your team admin to keep
            going</p>
        </div>
      </div>
      <div class="row" *ngIf="!isteamMember">
        <div class="col-md-10 mx-auto d-flex">
          <!-- <button data-testid="auto-person-search-contact-slider-button-6" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
          <button data-testid="auto-person-search-contact-slider-button-7" class="btn-trms-medium m-auto" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- No data found on reveal/preview -->
<ng-template #noDataFound>
  <div class="noDataFound mb-4">
    <div class="f-16 font-weight-600 d-flex justify-content-between" style="margin-bottom: 12px;">
      <span>
        <i class="fa-solid fa-file-exclamation mr-2" style="color: #2e93a1;"></i> No data found from our contact partners
      </span>
      <span *ngIf="!internalUser" (click)="closeNoDataFound()" style="cursor: pointer;">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      Try <span class="font-weight-600"> Webbtree Verified </span> from the options below, Get a Human verified contact number within 4
      hours.
    </div>
  </div>
</ng-template>


<!-- Person search contact slider -->
<div *ngIf="isAISourcingTab || (!isRevealContactLoading && !isFetchExistingContactPending)" class="personsearch-contact-slider">


  <!-- Contact info block -->
  <div>
    <div
      *ngIf="enrichedfrom === 'person-search-listing' && (work_email.length || phones.length || personal_email.length)"
      class="f-16 font-weight-600 mb-2">Contact Info</div>

    <div *ngIf="((enrichedfrom !== 'person-search-listing') && (!canShowAddToContact || (work_email.length || phones.length || personal_email.length))) " [ngClass]="canShowAddToContact ? 'manualContactActive' : 'manualContactDisable'"
      class="d-flex align-items-center justify-content-between">
      <span class="font-weight-600 f-16">Contact Info</span>
      <button data-testid="auto-person-search-contact-slider-button-8" *ngIf="!canShowAddToContact" class="btn-trms-medium" (click)="callAddToContactComponent()">
        <i class="fa-regular fa-plus mr-1"></i> New Contact
      </button>
    </div>


    <div *ngIf="work_email.length || personal_email.length || phones.length">
      <ng-template *ngIf="phones.length" [ngTemplateOutlet]="showAllPhone"></ng-template>
      <ng-template *ngIf="personal_email.length" [ngTemplateOutlet]="showAllPersonalEmail"></ng-template>
      <ng-template *ngIf="work_email.length" [ngTemplateOutlet]="showAllWorkEmail"></ng-template>
    </div>
  </div>

  <!-- <ng-template *ngIf="!internalUser && !isCloseNoDataFound && !isPreviewPending && candidateDetails?.revealContactAttempted && !(work_email.length || phones.length || personal_email.length)" [ngTemplateOutlet]="noDataFound"></ng-template> -->

  <!-- No Contact Details or preview found in case of internal user-->
  <div *ngIf="(contactDetails?.length == 0 && isAISourcingTab) || showTemplate('noDataFound-internalUser')" class="no-data-internal-user">
    <img src="assets/images/no-contact-found-internal-user.png" alt="">
    <div class="my-4">
      <i class="fa-solid fa-file-exclamation mr-2 f-16" style="color: #e54f7a;"></i>
      <span class="f-16 font-weight-600">
        Contact Not Available
      </span>
    </div>
  </div>

  <!-- Add contact manual block -->
  <div id="maual-contact-form" class="w-100">
    <app-add-contact-details-slider class="w-100" *ngIf="canShowAddToContact"
      (closeComponentEvent)="closeAddToContact($event)" [emailCampData]="emailCampData"
      [editInfo]="editManualContactInfo" [candidateNumber]="candidateNumber"></app-add-contact-details-slider>
  </div>

  <!-- Webtree-verified-sucess -->
  <div class="f-14 webtree-sucess mb-4" *ngIf="(candidateDetails?.iswebbtreeverified && !internalUser)">
    <div class="f-16 font-weight-600 mb-4">
      <img src="../../assets/images/webbtree-icon.svg" style="margin:0px 12px 0px 0px;" alt="webbtree_logo">
      Webbtree Verified
    </div>
    <div class="font-weight-600" style="margin-bottom: 12px;">
      <i class="fa-solid fa-circle-check f-16 mr-1" style="color: #e9ac0d;"></i> Request has been submitted successfully
    </div>
    <div>
      We will revert back to you with requested contact info on your Email ID within 4 business hours or we will return
      the credits back to your account
    </div>
  </div>

  <!-- Webtree-introduction-sucess -->
  <div class="f-14 webtree-sucess mb-4" *ngIf="candidateDetails?.usedWebbtreeIntroduction && !internalUser">
    <div class="f-16 font-weight-600 mb-4">
      <img src="../../assets/images/webbtree-icon.svg" style="margin:0px 12px 0px 0px;" alt="webbtree_logo">
      Webbtree Introduction
    </div>
    <div class="font-weight-600" style="margin-bottom: 12px;">
      <i class="fa-solid fa-circle-check f-16 mr-1" style="color: #e9ac0d;"></i> Request has been submitted successfully
    </div>
    <div>
      Our team will contact you to schedule a call and grasp the purpose behind reaching out to your targeted profile
    </div>
  </div>

  <div *ngIf="!hasAnyOfRequestSuccess && !internalUser">
    <ng-template [ngTemplateOutlet]="SelectRevealMethod"
      [ngTemplateOutletContext]="{headingText: 'Select a method to reveal contact'}">
    </ng-template>
  </div>


  <div *ngIf="!!internalUser && (isPreviewPending || showTemplate('contactPreviewLoading') || showTemplate('contactProvider'))">
    <ng-template [ngTemplateOutlet]="SelectRevealMethod"
      [ngTemplateOutletContext]="{headingText: 'Select a method to reveal contact'}">
    </ng-template>
  </div>

  <div class="" *ngIf="isRenderCurrentDiv('inital-state') && !hasAnyOfRequestSuccess">
    <ng-template *ngIf="isFullEnrichPending" [ngTemplateOutlet]="fullEnrichPending"></ng-template>
    <ng-template *ngIf="showTemplate('contactProvider') && !isAISourcingTab" [ngTemplateOutlet]="contactProvider"></ng-template>
    <ng-template *ngIf="showTemplate('contactPreviewLoading')" [ngTemplateOutlet]="contactPreviewLoading"></ng-template>
    <ng-template *ngIf="showTemplate('noDataFound')" [ngTemplateOutlet]="noDataFound"></ng-template>
    <ng-template *ngIf="showTemplate('webtreeVerified')" [ngTemplateOutlet]="webtreeVerified"></ng-template>
    <ng-template *ngIf="showTemplate('webtreeIntroduction')" [ngTemplateOutlet]="webtreeIntroduction"></ng-template>
  </div>

  <!-- The block above only renders while nothing has been found yet (!hasAnyOfRequestSuccess). A reveal
       can find some contacts (e.g. SignalHire) while FullEnrich is still working on the rest - show the
       pending message alongside them in that case too. -->
  <ng-template *ngIf="isFullEnrichPending && hasAnyOfRequestSuccess" [ngTemplateOutlet]="fullEnrichPending"></ng-template>

  <!-- Dropdown for alternative sources  -->
  <div class="contact-dropdown" *ngIf="isRenderCurrentDiv('alternative-source') && hasAnyOfRequestSuccess && !internalUser"
    [ngClass]="{'collapse': false}">
    <div class="dropdown-header" id="heading-dropdown-contact">
      <h5 class="f-14">
        <div class="w-100">
          <div class="f-14 w-100">
            <div class="d-flex w-100 align-items-baseline">
              <button data-testid="auto-person-search-contact-slider-button-9" id="contact-dropdown-btn" class="static font-weight-500 text-left flex-grow-1 btn f-14 p-0"
                type="button" data-bs-toggle="collapse" data-bs-target="#contact-dropdown" aria-expanded="false"
                aria-controls="contact-dropdown"> Not happy with the contact details?
              </button>
              <label for="collapseContactDropdownBtn" class="toggle text-webbtree-green">
                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                <span class="up mr-2"><i class="far fa-angle-up f-14 font-weight-300 pointer"></i></span>
              </label>
            </div>
          </div>
        </div>
      </h5>
    </div>

    <!-- Dropdown body -->
    <div id="contact-dropdown" class="collapse" [ngClass]="{'show': true}" aria-labelledby="contact-dropdown"
      *ngIf="!candidateDetails?.usedWebbtreeIntroduction || !candidateDetails?.iswebbtreeverified || !(candidateDetails?.revealContactAttempted || (!candidateDetails?.revealContactAttempted && isCloseNoDataFound) )">
      <div class="position-relative">
        <ng-template [ngTemplateOutlet]="SelectRevealMethod"
          [ngTemplateOutletContext]="{headingText: 'Select an alternative source to reveal contact details'}">
        </ng-template>

        <ng-template *ngIf="showTemplate('noDataFound')" [ngTemplateOutlet]="noDataFound"></ng-template>
        <ng-template *ngIf="showTemplate('contactProvider')" [ngTemplateOutlet]="contactProvider"></ng-template>
        <ng-template *ngIf="showTemplate('retryContactProvider')" [ngTemplateOutlet]="retryContactProvider"> </ng-template>
        <ng-template *ngIf="isPreviewPending && !revealContactAttempted" [ngTemplateOutlet]="contactPreviewLoading"></ng-template>

        <ng-template *ngIf="showTemplate('webtreeVerified')" [ngTemplateOutlet]="webtreeVerified"></ng-template>
        <ng-template *ngIf="showTemplate('webtreeIntroduction')" [ngTemplateOutlet]="webtreeIntroduction"></ng-template>
      </div>
    </div>
  </div>
</div>


<div *ngIf="isFetchExistingContactPending" class="personsearch-contact-slider text-center">
  <img style="width: 35px;" src="assets/rolling-loader.gif" alt="">
</div>
